import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();
    return (
        <footer className="footer-section">
            <div className="footer-top">
                <div className="footer-container">
                    <nav className="footer-nav">
                        <Link to="/terms-condition" className="footer-nav-link">이용약관</Link>
                        <span className="footer-separator">|</span>
                        <Link to="/privacy-policy" className="footer-nav-link">개인정보취급방침</Link>
                        <span className="footer-separator">|</span>
                        <Link to="/refusal-of-unauthorized" className="footer-nav-link">이메일무단수집거부</Link>
                    </nav>
                    <nav className="footer-nav">
                        <Link to="/contact-us" className="footer-nav-link">고객문의</Link>
                        <span className="footer-separator">|</span>
                        <Link to="/faq" className="footer-nav-link">자주하는 질문</Link>
                        <span className="footer-separator">|</span>
                        <Link to="/directions" className="footer-nav-link">오시는 길</Link>
                    </nav>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="footer-container">
                    <div className="footer-company-info">
                        <img
                            src="/images/Logo/footer-logo.png"
                            alt="파라다이스 추모원 로고"
                            className="footer-logo"
                            onClick={() => navigate('/')}
                        />
                        <div className="footer-company-details">
                            <div className="footer-company-details-top">
                                <div className="footer-company-details-top-left">
                                    <p>(주)강화파라다이스</p>
                                    <span>|</span>
                                    <p>대표자 : 강익순</p>
                                    <span>|</span>
                                    <p>사업자등록번호 : 119-81-62764</p>
                                </div>
                                <p>주소: 인천시 강화군 송해면 강화대로 879-16</p>
                                <p>Copyright(C)2018 Kanghwa Paradise All Rights Reserved.</p>
                            </div>

                            <div className="footer-company-details-info-mobile">
                                <div className="footer-company-details-info-mobile-top">
                                    <p>(주)강화파라다이스</p>
                                    <span className="separator">|</span>
                                    <p>분양상담 : <span>1599-9442</span></p>
                                </div>
                                <div className="footer-company-details-info-mobile-bottom">
                                    <div className="info-row">
                                        <span className="info-label">대표이사</span>
                                        <span className="info-value">강익순</span>
                                    </div>
                                    <div className="info-row">
                                        <span className="info-label">사업자등록번호</span>
                                        <span className="info-value">119-81-62764</span>
                                    </div>
                                    <div className="info-row">
                                        <span className="info-label">주소</span>
                                        <span className="info-value">인천시 강화군 송해면 강화대로 879-16</span>
                                    </div>
                                </div>
                                <p>Copyright(C)2018 Kanghwa Paradise All Rights Reserved.</p>
                            </div>

                            <div className="footer-company-details-bottom">
                                <a href="tel:1599-9442" className="footer-contact-button">
                                    <span className="footer-contact-text">분양상담 : 1599-9442</span>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </footer>
    );
}

export default Footer; 